var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bairun-container oiline-shop-add-category" },
    [
      _c(
        "el-form",
        {
          ref: "addAreaForm",
          staticClass: "add-area-form",
          attrs: { model: _vm.formData, "label-position": "right" }
        },
        [
          _c(
            "div",
            [
              _c("span", { staticClass: "divider-title" }, [
                _vm._v("二级类目配置")
              ]),
              _c("el-divider")
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "bairun-required",
                      attrs: { label: "选择店铺：" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { filterable: "", placeholder: "搜索条件" },
                          model: {
                            value: _vm.formData.sellerId,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "sellerId", $$v)
                            },
                            expression: "formData.sellerId"
                          }
                        },
                        _vm._l(_vm.sellerOptions, function(item) {
                          return _c("el-option", {
                            key: item.sellerId,
                            attrs: {
                              label: item.sellerName,
                              value: item.sellerId
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "bairun-required",
                      attrs: { label: "一级类目：" }
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { filterable: "", placeholder: "搜索条件" },
                          model: {
                            value: _vm.formData.categoryNo,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "categoryNo", $$v)
                            },
                            expression: "formData.categoryNo"
                          }
                        },
                        _vm._l(_vm.categoryOptions, function(item) {
                          return _c("el-option", {
                            key: item.categoryNo,
                            attrs: { label: item.name, value: item.categoryNo }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "bairun-required",
                      attrs: { label: "二级类目名称：" }
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入内容" },
                        on: {
                          input: function($event) {
                            return _vm.inputChange($event)
                          }
                        },
                        model: {
                          value: _vm.formData.showAreaName,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "showAreaName", $$v)
                          },
                          expression: "formData.showAreaName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "goods-img-content" },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "bairun-required",
                      attrs: { label: "二级类目图标：" }
                    },
                    [
                      _c(
                        "div",
                        [
                          _c("el-input", {
                            staticStyle: { width: "200px" },
                            attrs: { placeholder: "请输入链接地址" },
                            on: {
                              blur: function($event) {
                                return _vm.onAddImgUrl("addAreaImgUrl")
                              },
                              input: function($event) {
                                return _vm.inputChange($event)
                              }
                            },
                            model: {
                              value: _vm.addAreaImgUrl,
                              callback: function($$v) {
                                _vm.addAreaImgUrl = $$v
                              },
                              expression: "addAreaImgUrl"
                            }
                          })
                        ],
                        1
                      ),
                      _c("upload-image", {
                        staticStyle: { display: "inline-block" },
                        attrs: {
                          "file-size": 200,
                          "is-press": true,
                          "max-w-h": 1080,
                          multiple: true,
                          "auto-upload": true,
                          height: "200px",
                          width: "200px",
                          tips: "建议尺寸1:1，自动压缩，不超过200kb"
                        },
                        on: { onUploadSuccess: _vm.areaImgUploadSuccess }
                      }),
                      _c(
                        "draggable",
                        {
                          staticClass: "draggable-content",
                          attrs: {
                            group: "showAreaImgUrl",
                            animation: "500",
                            "chosen-class": "bairun-draggable-chosen"
                          },
                          model: {
                            value: _vm.formData.showAreaImgUrl,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "showAreaImgUrl", $$v)
                            },
                            expression: "formData.showAreaImgUrl"
                          }
                        },
                        [
                          _c(
                            "transition-group",
                            {
                              attrs: {
                                type: "transition",
                                name: "showAreaImgUrl-list"
                              }
                            },
                            _vm._l(_vm.formData.showAreaImgUrl, function(
                              item,
                              index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: "showAreaImgUrl" + index,
                                  staticClass: "goods-area-img bairun-margin-l"
                                },
                                [
                                  _c("el-image", {
                                    attrs: {
                                      src: item,
                                      fit: "fit",
                                      "preview-src-list":
                                        _vm.formData.showAreaImgUrl
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "el-image-viewer__btn el-image-viewer__close",
                                      on: {
                                        click: function($event) {
                                          return _vm.onDeleteAreaImg(index)
                                        }
                                      }
                                    },
                                    [_c("i", { staticClass: "el-icon-close" })]
                                  )
                                ],
                                1
                              )
                            }),
                            0
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序：" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, placeholder: "请输入内容" },
                        model: {
                          value: _vm.formData.weight,
                          callback: function($$v) {
                            _vm.$set(_vm.formData, "weight", $$v)
                          },
                          expression: "formData.weight"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.formData.showAreaStatus,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "showAreaStatus", $$v)
                            },
                            expression: "formData.showAreaStatus"
                          }
                        },
                        [
                          _c("el-radio", { attrs: { label: 5 } }, [
                            _vm._v("启用")
                          ]),
                          _c("el-radio", { attrs: { label: 6 } }, [
                            _vm._v("禁用")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 50 } },
            [
              _c(
                "el-col",
                { attrs: { span: 20 } },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "bairun-required",
                      attrs: { label: "二级类目商品：" }
                    },
                    [
                      _c(
                        "draggable",
                        {
                          staticClass: "draggable-content",
                          attrs: {
                            group: "showAreaDetailList",
                            animation: "500",
                            "chosen-class": "bairun-draggable-chosen"
                          },
                          model: {
                            value: _vm.formData.showAreaDetailList,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "showAreaDetailList", $$v)
                            },
                            expression: "formData.showAreaDetailList"
                          }
                        },
                        [
                          _c(
                            "transition-group",
                            {
                              attrs: {
                                type: "transition",
                                name: "show-area-detail-list"
                              }
                            },
                            _vm._l(_vm.formData.showAreaDetailList, function(
                              areaItem,
                              areaIndex
                            ) {
                              return _c(
                                "div",
                                {
                                  key: areaIndex,
                                  staticClass:
                                    "bairun-grey-pannel bairun-margin-b bairun-position-r"
                                },
                                [
                                  _c(
                                    "el-row",
                                    [
                                      _c(
                                        "el-col",
                                        { attrs: { span: 2 } },
                                        [
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "bairun-margin-l",
                                              attrs: {
                                                type: "primary",
                                                icon: "el-icon-add"
                                              },
                                              on: {
                                                click: function($event) {
                                                  return _vm.onAddGoods(
                                                    areaItem
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v("添加商品")]
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-row",
                                    [
                                      _c("el-col", { attrs: { span: 24 } }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "online-shop-goods-table bairun-margin-t"
                                          },
                                          [
                                            _c(
                                              "el-table",
                                              {
                                                ref: "table",
                                                refInFor: true,
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  data:
                                                    areaItem.showAreaDetailGoodsList,
                                                  "tooltip-effect": "dark"
                                                }
                                              },
                                              [
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "默认spu图标",
                                                    width: "100",
                                                    align: "right"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(scope) {
                                                          return [
                                                            _c("el-image", {
                                                              attrs: {
                                                                src:
                                                                  scope.row
                                                                    .imgUrl,
                                                                fit: "contain",
                                                                "preview-src-list": [
                                                                  scope.row
                                                                    .imgUrl
                                                                ]
                                                              }
                                                            })
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                }),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "商品详情名称",
                                                    width: "400"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(scope) {
                                                          return [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "table-goods-info"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "bairun-table-goods-name"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        scope
                                                                          .row
                                                                          .goodsDetailTitle
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  [
                                                                    scope.row
                                                                      .isHot ==
                                                                    1
                                                                      ? _c(
                                                                          "el-tag",
                                                                          {
                                                                            attrs: {
                                                                              type:
                                                                                "danger",
                                                                              size:
                                                                                "mini",
                                                                              effect:
                                                                                "plain"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "热卖"
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e(),
                                                                    _vm._v(
                                                                      "   "
                                                                    ),
                                                                    scope.row
                                                                      .isRecommend ==
                                                                    1
                                                                      ? _c(
                                                                          "el-tag",
                                                                          {
                                                                            attrs: {
                                                                              type:
                                                                                "primary",
                                                                              size:
                                                                                "mini",
                                                                              effect:
                                                                                "plain"
                                                                            }
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              "推荐"
                                                                            )
                                                                          ]
                                                                        )
                                                                      : _vm._e()
                                                                  ],
                                                                  1
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "bairun-rotate-tag"
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm._f(
                                                                        "getActivityTypes"
                                                                      )(
                                                                        scope
                                                                          .row
                                                                          .activityTypes
                                                                      )
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                }),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "二级类目",
                                                    prop: "categoryName"
                                                  }
                                                }),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "提货方式",
                                                    prop: "logisticsTypes"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(scope) {
                                                          return [
                                                            scope.row
                                                              .logisticsTypes ==
                                                            "1"
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "门店自提"
                                                                  )
                                                                ])
                                                              : _vm._e(),
                                                            scope.row
                                                              .logisticsTypes ==
                                                            "2"
                                                              ? _c("span", [
                                                                  _vm._v("包邮")
                                                                ])
                                                              : _vm._e(),
                                                            scope.row
                                                              .logisticsTypes ==
                                                            "1,2"
                                                              ? _c("span", [
                                                                  _vm._v(
                                                                    "包邮或门店自提"
                                                                  )
                                                                ])
                                                              : _vm._e()
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                }),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "排序",
                                                    prop: "weight"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(scope) {
                                                          return [
                                                            _c(
                                                              "el-input-number",
                                                              {
                                                                attrs: {
                                                                  min: 0
                                                                },
                                                                on: {
                                                                  change: function() {
                                                                    _vm.onGoodsWeightChange(
                                                                      areaItem
                                                                    )
                                                                  }
                                                                },
                                                                model: {
                                                                  value:
                                                                    scope.row
                                                                      .weight,
                                                                  callback: function(
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      scope.row,
                                                                      "weight",
                                                                      $$v
                                                                    )
                                                                  },
                                                                  expression:
                                                                    "scope.row.weight"
                                                                }
                                                              }
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                }),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "状态",
                                                    prop: "showStatus"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(scope) {
                                                          return [
                                                            scope.row
                                                              .showStatus == 1
                                                              ? _c(
                                                                  "el-tag",
                                                                  {
                                                                    attrs: {
                                                                      type:
                                                                        "primary",
                                                                      size:
                                                                        "mini",
                                                                      effect:
                                                                        "plain"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "已上架"
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            scope.row
                                                              .showStatus == 2
                                                              ? _c(
                                                                  "el-tag",
                                                                  {
                                                                    attrs: {
                                                                      type:
                                                                        "danger",
                                                                      size:
                                                                        "mini",
                                                                      effect:
                                                                        "plain"
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "已下架"
                                                                    )
                                                                  ]
                                                                )
                                                              : _vm._e()
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                }),
                                                _c("el-table-column", {
                                                  attrs: {
                                                    label: "操作",
                                                    width: "100"
                                                  },
                                                  scopedSlots: _vm._u(
                                                    [
                                                      {
                                                        key: "default",
                                                        fn: function(scope) {
                                                          return [
                                                            _c(
                                                              "el-button",
                                                              {
                                                                staticClass:
                                                                  "table-button",
                                                                attrs: {
                                                                  size: "small",
                                                                  type: "danger"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.stopPropagation()
                                                                    return _vm.onDelGoods(
                                                                      areaItem,
                                                                      scope.row
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [_vm._v("删除")]
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ],
                                                    null,
                                                    true
                                                  )
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            0
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "bairun-bottom-tool" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function() {
                  _vm.onCache()
                  _vm.goBack()
                }
              }
            },
            [_vm._v("返回")]
          ),
          _c("el-button", { on: { click: _vm.onClear } }, [_vm._v("清空")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.onSave } },
            [_vm._v("提交")]
          )
        ],
        1
      ),
      _vm.goodsComponentFormData.dialogVisible
        ? _c("GoodsSelectComponent", {
            ref: "GoodsSelectComponent",
            attrs: { "goods-component-form-data": _vm.goodsComponentFormData }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }